<template>
	<div class="anjian">
		<div v-wechat-title="$route.meta.title"></div>
		<Card class='card-left'>
			<Menu mode="vertical" theme="light" :active-name="menuName"  @on-select='menuItem' :open-names="openNames">
				<div v-for="(item,index) in userInfo.menuList.statistics.children" :name="item.key" :key="index" >
					<MenuItem v-if="item.children.length == 0" :name="item.key" :key="index" >
						<img :src="iconList[index]" class="menuIcon"/>
						<span style="font-weight: bold;">{{item.name}}</span>
					</MenuItem>
					<Submenu v-else :name="item.key">
						<template slot="title">
							<img :src="iconList[index]" class="menuIcon"/>
							<span style="font-weight: bold;">{{item.name}}</span>
						</template>
						<MenuItem v-for="(value,key) in item.children" :name="value.key" :key="key">{{value.name}}</MenuItem>
					</Submenu>
				</div>
			</Menu>
		</Card>
		<div class='card-right-top'>
			<ClientGrossAnalyse v-if="menuName == 'client_gross_analyse' "></clientGrossAnalyse>
			<ClientFollowAnalyse v-if="menuName == 'client_follow_analyse' "></ClientFollowAnalyse>
			<ClientVisitAnalyse v-if="menuName == 'client_visit_analyse' "></ClientVisitAnalyse>
			<PublicClientAnalyse v-if="menuName == 'public_client_analyse' "></PublicClientAnalyse>
			<ChangePeriodAnalyse v-if="menuName == 'change_period_analyse' "></ChangePeriodAnalyse>
			<SynthesizeAnalyse v-if="menuName == 'synthesize_analyse' "></SynthesizeAnalyse>
			<RankingList :menuName="menuName" v-if="menuName == 'performance_ranking' ||  menuName == 'door_ranking'||  menuName == 'sign_ranking'||  menuName == 'loan_ranking'||  menuName == 'follow_up_ranking'"></RankingList>
		</div>
	</div>
</template>

<script> 
  import ClientGrossAnalyse from './ClientGrossAnalyse.vue'
	import ClientFollowAnalyse from './ClientFollowAnalyse.vue'
	import ClientVisitAnalyse from './ClientVisitAnalyse.vue'
	import PublicClientAnalyse  from './PublicClientAnalyse.vue'
	import ChangePeriodAnalyse  from './ChangePeriodAnalyse.vue'
	import SynthesizeAnalyse  from './SynthesizeAnalyse.vue'
	import RankingList  from './RankingList.vue'
  import {mapGetters} from "vuex";
	export default {
		name: "Statistics",
		components: {
			ClientGrossAnalyse,
			ClientFollowAnalyse,
			ClientVisitAnalyse,
			PublicClientAnalyse,
			ChangePeriodAnalyse,
			SynthesizeAnalyse,
			RankingList
		},
		computed: {
			...mapGetters(['userInfo'])
		},
		data() {
			return {
				menuName: 'client_gross_analyse',
				openNames: [''],
				iconList: []
			}
		},
		created() {
			// 初始化菜单图标
			this.initIcon();
			var menu = this.$route.query.menu;
			if (menu == 'performance_ranking') {
				this.menuName = 'performance_ranking'
				this.openNames = ['rank_list']
			}
		},
		watch: {
			$route(to, from) {
				var menu = this.$route.query.menu;
				if (menu == 'performance_ranking') {
					this.menuName = 'performance_ranking'
					this.openNames = ['rank_list']
				}
			}
		},
		methods: {
			initIcon() {
				let that = this
				this.userInfo.menuList.statistics.children.forEach(function (row, index) {
					index = parseInt(index)
					that.iconList[index] = require('../../assets/icons/statistics/'+row.key+'.png');
				})
			},
			menuItem(e) {
				this.menuName = e;
			},
		}

	}
</script>

<style scoped  lang="less">

	.menuIcon{
		display: inline-block;
		width: 15px;
		height: 15px;
		vertical-align: middle;
		margin-bottom: 3px;
		margin-right: 5px;
	}
</style>